var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body",class:{ scroll: _vm.scroll },style:(_vm.scroll ? 'max-height: ' + _vm.height : '')},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }